import { apiInfluencersAnalisys } from './apiInfluencersAnalisys'

const apiDiscounts = {
	...apiInfluencersAnalisys,
}

export { apiDiscounts }
